module.exports = __webpack_public_path__ + "static/media/solutions.64ff5db9.mp3";